import { useMutation } from '@tanstack/react-query';
import { getAuthorizationCode } from '../services/ai-studio.service';
import appConfig from 'app-config';
import { AiStudioRedirections } from '../types/AiStudioTypes';
import { getBrand } from 'flow/brands/brands';
import useAppContext from 'flow/hooks/useAppContext';
import { getReadMoreUrl } from '../utils/ai-studio-utils';

const useAiStudioSettings = () => {
    const {
        mutateAsync: getAuthCode,
        data: authCodeData,
        isPending: isAuthcodeLoading,
        error: authCodeError,
        reset: clearAuthCode,
    } = useMutation({
        mutationFn: getAuthorizationCode,
    });

    const { i18next } = useAppContext();

    const aiStudioBaseUrl = appConfig.aiStudioBaseUrl;

    const getAdminUrl = () => {
        const proxyHost = process.env.PROXY_HOST;
        return proxyHost ? `https://${proxyHost}` : getBrand().brandAdminUrl;
    };

    const redirections = {
        dashboard: `${aiStudioBaseUrl}/auth/callback/telavox`,
        readMore: getReadMoreUrl(i18next?.language),
        createAccount: `${getAdminUrl()}/aiagents.jsp#/general-information`,
    } as AiStudioRedirections;

    return {
        getAuthCode,
        clearAuthCode,
        authCodeData,
        isAuthcodeLoading,
        authCodeError,
        redirections,
    };
};

export default useAiStudioSettings;
